import React from 'react'
import styled from 'styled-components'
import White from '../white'
import Container from '../container'
import Portable from '../portable'
import Portable2 from '../portable2'
import ButtonWhite from '../button_white'

const Intro = styled.h3`
  margin-left: 0;
  margin-bottom: 2rem;
`

const Wrapper = styled.div`
  width: 100%;
  padding-top: 75px;
  padding-bottom: 75px;
  @media(max-width: 768px) {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  h2 {
    max-width: 100%;
    margin-bottom: 66px;
    &.mb0 {
      margin-bottom: 2rem;
    }
  }
`

const ButtonContainer = styled.div`
  margin-bottom: 100px;
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 2rem;
  @media(max-width: 768px) {
    flex-direction: column;
  }
`

const Col = styled.div`
  width: 50%;
  @media(max-width: 768px) {
    width: 100%;
    margin-bottom: 1rem;
  }
`

const Column2 = props => {

  const { module } = props;

  return (
    <White>
      <Container>
        <Wrapper>
          {module.heading && <h2 className={module?.cta_link ? 'mb0' : ''}>{module.heading}</h2> }
          {module.cta_text && module.cta_link &&
            <ButtonContainer>
            <ButtonWhite
              link={
                module.cta_link.includes("https")
                  ? module.cta_link
                  : `/${module.cta_link}`
              }
            >
            {module.cta_text}
          </ButtonWhite>
          </ButtonContainer>
        }
        {module.intro &&
          <Intro>{module.intro}</Intro>
        }
        <Row>
          <Col><Portable2 value={module._rawBodyLeft} /></Col>
          <Col><Portable2 value={module._rawBodyRight} /></Col>
          </Row>
        </Wrapper>
      </Container>
      <hr />
    </White>
  )
}

export default Column2
